var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgArrowsRight = function SvgArrowsRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "arrows-right_svg__icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M671.469 621.75V500.625H65.375a15.524 15.524 0 0 1-15.563-15.563v-202.03a15.524 15.524 0 0 1 15.563-15.563h606.094V146.25c0-3.75 1.406-7.406 3.843-10.219 5.625-6.469 15.47-7.125 21.938-1.5l271.688 237.75 1.5 1.5c5.625 6.469 4.968 16.313-1.5 21.938L697.25 633.375c-2.813 2.438-6.469 3.844-10.219 3.844-8.625 0-15.562-6.938-15.562-15.469z"
  })));
};

export default SvgArrowsRight;